import { createSlice } from "@reduxjs/toolkit";

const bulkSparesFilterSlice = createSlice({
  name: "bulkSparesFilter",
  initialState: {
    seller_id: "",
    status: "",
  },
  reducers: {
    setBulkSparesFilter: (state, action) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setBulkSparesFilter } = bulkSparesFilterSlice.actions;

export const selectBulkSparesFilterState = (state) =>
  state.bulkSparesFilter;

export default bulkSparesFilterSlice.reducer;
